export const animation = {
  deleteAnimation: 'حذف رسم متحرك',
  deleteConfirm:
    'هل أنت متأكد أنك تريد حذف هذا الرسم المتحرك؟ لا يمكن التراجع عن هذا الإجراء.',
  toggleActiveTitle: 'تغيير حالة الرسم المتحرك',
  toggleActiveToActive: 'هل أنت متأكد أنك تريد تفعيل هذا الرسم المتحرك؟',
  toggleActiveToInactive: 'هل أنت متأكد أنك تريد إيقاف تفعيل هذا الرسم المتحرك؟',
  status: 'الحالة',
  pending: 'قيد الانتظار',
  started: 'بدأ',
  expired: 'منتهى',
  active: 'نشط',
  inactive: 'غير نشط',
  appBarTitle: 'الرسوم المتحركة',
  title: 'الرسوم المتحركة',
  addAnimation: 'إضافة',
  editAnimation: 'تعديل',
  uploadFile: 'تحميل ملف الرسوم المتحركة',
  uploadFileEn: 'ملف الرسوم المتحركة بالإنجليزية',
  uploadFileAr: 'ملف الرسوم المتحركة بالعربية',
  name: 'اسم ملف الرسوم المتحركة',
  startDate: 'تاريخ البداية',
  endDate: 'تاريخ الانتهاء',
  fileSize: 'حجم الملف',
  backgroundColor: 'لون الخلفية',
  validation: {
    endDateAfterStartDate: 'يجب أن يكون تاريخ البداية قبل تاريخ الانتهاء',
    fileIsRequired: 'ملف JSON مطلوب',
    animationFileNameRequired: 'اسم ملف الرسوم المتحركة مطلوب',
    backgroundColorRequired: 'لون الخلفية مطلوب',
    backgroundColorInvalid: 'يرجى إدخال لون صحيح بالهيكس (مثال: #AABBCC)',
    startDateRequired: 'تاريخ البداية مطلوب',
    endDateRequired: 'تاريخ الانتهاء مطلوب',
    startDateInvalid: 'تاريخ البداية غير صالح',
    endDateInvalid: 'تاريخ الانتهاء غير صالح',
  },
  success: {
    saved: 'تم حفظ الرسوم المتحركة بنجاح',
  },
  error: {
    saveFailed: 'فشل في حفظ الرسوم المتحركة',
  },
  animationDetails: {
    animationDetails: 'تفاصيل الرسم المتحرك',
    englishAnimationFile: 'ملف الرسم المتحرك بالإنجليزية',
    arabicAnimationFile: 'ملف الرسم المتحرك بالعربية',
    status: {
      started: 'بدأ',
      expired: 'منتهى',
      pending: 'قيد الانتظار',
      active: 'نشط',
      inactive: 'غير نشط',
    },
    animationName: 'اسم الرسم المتحرك',
    backgroundColor: 'لون الخلفية',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ الانتهاء',
  },
};
